// extracted by mini-css-extract-plugin
module.exports = {"rootSvg":"b3NV1kQn","axisLine":"PlclMspT","axisText":"FC6a3qoB","axisTextHeader":"Ztgba_yK","labelHeader":"wamLn5y2","slide-in":"HNphu88l"};